import FingerprintJS from '@fingerprintjs/fingerprintjs';
import type { DeviceFingerprint } from '@/types/fingerprint';

let fpPromise: Promise<any> | null = null;

function getAgent() {
  if (!fpPromise) {
    fpPromise = FingerprintJS.load();
  }
  return fpPromise;
}

export async function collectFingerprint(): Promise<DeviceFingerprint | null> {
  try {
    const agent = await getAgent();
    const result = await agent.get();

    return {
      visitorId: result.visitorId,
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      colorDepth: window.screen.colorDepth,
      hardwareConcurrency: navigator.hardwareConcurrency || 0,
      deviceMemory: (navigator as any).deviceMemory ?? null,
      touchSupport: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      timezoneOffset: new Date().getTimezoneOffset(),
      language: navigator.language,
      cookiesEnabled: navigator.cookieEnabled,
      doNotTrack: navigator.doNotTrack === '1',
    };
  } catch {
    return null;
  }
}

let cachedFingerprint: DeviceFingerprint | null = null;

export async function getFingerprint(): Promise<DeviceFingerprint | null> {
  if (!cachedFingerprint) {
    cachedFingerprint = await collectFingerprint();
  }
  return cachedFingerprint;
}

export function getFingerprintHeader(): string | null {
  if (!cachedFingerprint) return null;
  try {
    return btoa(JSON.stringify(cachedFingerprint));
  } catch {
    return null;
  }
}
